import React from "react";
export var BusinessUnitInput = /*#__PURE__*/ React.forwardRef(function BaseBusinessUnitInput(param, ref) {
    var businessAddresses = param.businessAddresses, selectedBusinessId = param.selectedBusinessId, name = param.name, onChange = param.onChange;
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("h5", null, "Business Unit"), /*#__PURE__*/ React.createElement("select", {
        name: name,
        onChange: onChange,
        "data-testid": "business-unit-select",
        ref: ref,
        defaultValue: selectedBusinessId
    }, businessAddresses.map(function(param) {
        var name = param.name, id = param.id;
        return /*#__PURE__*/ React.createElement("option", {
            key: id,
            value: id
        }, name);
    })));
});
